import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useAuthStore } from "@/app/state/auth-store";
import { useCartStore } from "@/app/state/cart-store";
import { useUIStore } from "@/app/state/ui-store";
import { normalizeLocale } from "@/i18n";

export function CartBootstrap() {
    const { i18n } = useTranslation();
    const authStatus = useAuthStore(state => state.status);
    const sessionVersion = useAuthStore(state => state.sessionVersion);
    const loadCart = useCartStore(state => state.loadCart);
    const clearCart = useCartStore(state => state.clearCart);
    const setCartOpen = useUIStore(state => state.setCartOpen);
    const locale = normalizeLocale(i18n.language);

    useEffect(() => {
        if (authStatus === "authenticated") {
            clearCart();
            setCartOpen(false);
            void loadCart(locale);
        }
        else if (authStatus === "anonymous") {
            clearCart();
            setCartOpen(false);
        }
    }, [authStatus, clearCart, loadCart, locale, sessionVersion, setCartOpen]);

    return null;
}
